import { ConnectorChannelIcon } from "#components/ui/ConnectorChannelIcon.tsx";
import { Channel } from "#features/channels/components/channels-details/Channel.tsx";
import { channels } from "#features/conversations/types/channels.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Text } from "@hopper-ui/components";

export const WpmChannel = () => {
    const { tShared } = useSharedTranslation();
    const { nameKey } = channels["WorkleapPerformance"];

    return (
        <Channel
            icon={<ConnectorChannelIcon type="WorkleapPerformance" />}
            title={tShared(nameKey)}
        >
            <Flex direction="column" gap="inline-sm">
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapPerformanceReviewCycle")}
                </Text>
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapPerformanceReview")}
                </Text>
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapPerformancePeerReviewNomination")}
                </Text>
            </Flex>
        </Channel>
    );
};
